import {useEffect, useState} from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import { useDeleteUserMutation, useEditUserProfileMutation, useGetUserProfileByIdQuery } from '../../Features/usersSlice';
import LoadingBar from "react-top-loading-bar";
import { useIsOnline } from 'react-use-is-online';



function UserProfileEditView() {
    const navigate = useNavigate();
    const { user_id } = useParams();
    const [input, setInput] = useState({});
    const [progress, setProgress] = useState(0);
    const { isOnline } = useIsOnline();



    const handleChange = (e)=>{
        setInput({...input, [e.target.name]: e.target.value})
    }

    const [errors, setErrors] = useState({
        password: '',
        password_comfirm: '',
        email: '',
        phone: '',
        fname: '',
        lname: '',
        gender: '',
        business_name: ''
    })

    const {
        data: user,
        isLoading,
        isSuccess,
        isError
    } = useGetUserProfileByIdQuery(user_id)

    useEffect(()=>{
            setProgress(40)
        if(isLoading){
            setProgress(80)
        }

        if(isSuccess && user.hasOwnProperty("data")){
            setInput(user.data)
            setProgress(100)
        }
        return () =>{
        }
    },[user]);

    const [editUserProfile] = useEditUserProfileMutation()

    const handleSubmit = async(e)=>{
        e.preventDefault();
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again',"error");
        }
        if(input.password !== input.password_comfirm){
            return swal("Password and comfirm password don't match");
        }
        try {
            setProgress(80)
            const resp = await editUserProfile(input).unwrap()
            if(resp.hasOwnProperty('success') == true){
                setProgress(100)
                return navigate(-1);
            }
        } catch (err) {
            setProgress(100)
            if(err.data.hasOwnProperty('errors') == true){
                setErrors({
                    ...errors, 
                    fname: err.data.errors.fname,
                    lname: err.data.errors.lname,
                    email: err.data.errors.email,
                    phone: err.data.errors.phone,
                    business_name: err.data.errors.business_name,
                    gender: err.data.errors.gender,
                    
                })
            }else if(err.data.hasOwnProperty('error')){
                return swal("Registration Failed",err.data.error,"error");
            }
        }          
    }

    const [deleteUser] = useDeleteUserMutation();

    const handDeleteUser = async(e,id)=>{
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again',"error"); 
        }
        if(window.confirm("Are you sure you want to delete this user?")){
            try {
                setProgress(80)
            const resp = await deleteUser(user_id).unwrap();
            if(resp.hasOwnProperty('success') == true){
                setProgress(100)
                return navigate(-1);
            }
        } catch (err) {
            setProgress(100)
            swal("Error",err.message,'error');
        }
          }
    }

    const back = ()=> {
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again',"error"); 
        }
        setProgress(100)
        navigate(-1)
    };

    return(
            <div className="flex md:w-2/3 mb-12">
                <LoadingBar
                color="#14b8a6"
                height="4px"
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
                />
                <div className=''>     
                    {
                        (isSuccess)?
                            <div class="bg-white shadow-md rounded-md flex flex-col justify-center">
                                <div class="p-3">
                                    <form onSubmit={handleSubmit} autoComplete="off" >
                                        <div class="divide-y divide-gray-200">
                                            <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-2">
                                                    <label for="fname" class="block text-xs text-gray-500">First name</label>
                                                    <input 
                                                        class="mt-1 p-2 outline-none focus:border-green-500 block w-full text-gray-700 text-sm  border-b border-gray-300"
                                                        type="text"
                                                        name="fname" 
                                                        id="fname" 
                                                        value={input.fname}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-800 p-0 m-0">{errors.fname}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-2">
                                                    <label for="lname" class="block text-xs text-gray-500">Last name</label>
                                                    <input 
                                                        class="mt-1 p-2 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="text"
                                                        name="lname" 
                                                        id="lname" 
                                                        value={input.lname}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-800 p-0 m-0">{errors.lname}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-2">
                                                    <label for="email" class="block text-xs text-gray-500">Email</label>
                                                    <input 
                                                        class="mt-1 p-2 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="text"
                                                        name="email" 
                                                        id="email" 
                                                        value={input.email}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-800 p-0 m-0">{errors.email}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-2">
                                                    <label for="phone" class="block text-xs text-gray-500">Phone number</label>
                                                    <input 
                                                        class="mt-1 p-2 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="text"
                                                        name="phone" 
                                                        id="phone" 
                                                        value={input.phone}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-800 p-0 m-0">{errors.phone}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-2">
                                                    <label for="business_name" class="block text-xs text-gray-500">Business name</label>
                                                    <input 
                                                        class="mt-1 p-2 outline-none focus:border-green-500 block w-full text-gray-700 text-xs border-b border-gray-300"
                                                        type="text"
                                                        name="business_name" 
                                                        id="business_name" 
                                                        value={input.business_name}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-800 p-0 m-0">{errors.business_name}</p>
                                                </div>
                                            </div>
                                            <div className='flex flex-col'>
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="number" class="w-full block text-xs text-gray-500">Gender</label>       
                                                    <select value={input.gender} name='gender' onChange={handleChange} className='mt-1 p-2 outline-none focus:border-green-500 block w-full text-gray-700 text-sm  border-b border-gray-300'>
                                                        <option value={false} className='text-gray-800 text-sm'>Select</option>
                                                        <option value={1} className='text-gray-800 text-sm'>Male</option>
                                                        <option value={2} className='text-gray-800 text-sm'>Female</option>
                                                    </select>
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.gender}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="password" class="block text-xs text-gray-500">New password</label>
                                                    <input 
                                                        class="mt-1 p-1 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="password"
                                                        name="password" 
                                                        id="password" 
                                                        value={input.password}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.password}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="password" class="block text-xs text-gray-500">Confirm Password</label>
                                                    <input 
                                                        class="mt-1 p-1 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="password"
                                                        name="password_comfirm" 
                                                        id="password_comfirm" 
                                                        value={input.password_comfirm}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.password_comfirm}</p>
                                                </div>
                                            </div>
                                            <div class="flex items-center justify-between space-x-3 w-full border-t  border-gray-200">
                                                <div class="flex flex-col text-gray-400 flex-wrap w-2/3">
                                                    <label class="text-gray-700 text-sm">Delete user</label>
                                                    <div class="text-sm">You can permanently delete this user account and all its data</div>
                                                </div>
                                                <div class="flex justify-end text-sm">
                                                    <div onClick={(e)=>handDeleteUser(e, input.id)} className='px-x-2 text-green-500 font-bold uppercase cursor-pointer rounded-md'>Delete</div>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="pt-4 flex items-end space-x-4">
                                                <div onClick={back} class="flex cursor-pointer hover:bg-gray-50 justify-center items-center w-full text-gray-900 px-4 py-3 rounded-md focus:outline-none">
                                                    Cancel
                                                </div>
                                                <button type='submit' class="bg-green-500 flex justify-center items-center w-full text-white px-4 py-3 rounded-md focus:outline-none">Save</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        :isError?
                            <div className="md:flex flex-col p-4">
                                <p className="text-blue-500 italic border-b border-black flex flex-1">You do not have any seating profile available</p>
                            </div>
                        :null
                    }
                </div>
            </div>
        )

}

export default UserProfileEditView;
